import { ReceivedPublicBidDto, SourcingEventV2Dto } from "../../../autogen/bff-api";

// One row in the Tilbud tab: a company that has either registered interest, delivered a bid, or
// both. Whether a registrant delivered (`bid`) is only ever populated by the BFF after the
// submission deadline — the bid-list endpoint returns nothing before then — so this type cannot
// disclose who submitted while bidding is still open.
export interface SupplierRow {
  organizationId: string;
  organizationName: string;
  registeredAt?: string;
  bid?: ReceivedPublicBidDto;
}

export const buildSupplierRows = (
  event: SourcingEventV2Dto,
  bids: ReceivedPublicBidDto[],
): SupplierRow[] => {
  const byOrg = new Map<string, SupplierRow>();

  for (const registration of event.supplierRegistrations ?? []) {
    byOrg.set(registration.organizationId, {
      organizationId: registration.organizationId,
      organizationName: registration.organizationName,
      registeredAt: registration.registeredAt,
    });
  }

  for (const bid of bids) {
    const existing = byOrg.get(bid.owner);
    if (existing) {
      existing.bid = bid;
    } else {
      byOrg.set(bid.owner, {
        organizationId: bid.owner,
        organizationName: bid.ownerName,
        bid,
      });
    }
  }

  return Array.from(byOrg.values()).sort((a, b) =>
    a.organizationName.localeCompare(b.organizationName),
  );
};

export const isBidDeadlinePassed = (event: SourcingEventV2Dto): boolean => {
  const deadline = event.eventData.bidSubmissionDeadline;
  return deadline != null && new Date(deadline).getTime() <= Date.now();
};
